module.exports = __webpack_public_path__ + "c63794bab9f27ab42b4765a982c24342.pdf";